import api from "./API";
import ApiEndpointConstants from "../constants/ApiEndpointConstants";

export const getCategory = (id) => {
  return api.post(`${ApiEndpointConstants.GET_CATEGORY}`, { id });
};

export const setCategory = (name, id) => {
  return api.post(`${ApiEndpointConstants.ADD_CATEGORY}`, { name, id });
};

export const deleteCategory = (id) => {
  return api.post(`${ApiEndpointConstants.DELETE_CATEGORY}`, { id });
};
